import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const MIN_SHEET_NAME_LENGTH = 3;
export const MAX_SHEET_NAME_LENGTH = 31;

const INVALID_SHEET_NAME_PATTERN = /[?:\\\/[\]*]/;

export const trimSheetName = (value?: string | null) => (value || '').trim();

export const trimmedLengthValidator = (
  minLength = MIN_SHEET_NAME_LENGTH,
  maxLength = MAX_SHEET_NAME_LENGTH
): ValidatorFn => {
  return (control: AbstractControl<string | null>): ValidationErrors | null => {
    const trimmedValue = trimSheetName(control.value);

    if (!trimmedValue.length) {
      return { required: true };
    }

    if (trimmedValue.length < minLength) {
      return {
        minlength: {
          requiredLength: minLength,
          actualLength: trimmedValue.length,
        },
      };
    }

    if (trimmedValue.length > maxLength) {
      return {
        maxlength: {
          requiredLength: maxLength,
          actualLength: trimmedValue.length,
        },
      };
    }

    return null;
  };
};

export const sheetNameValidator = (
  getSheetNames: () => string[] = () => []
): ValidatorFn => {
  return (control: AbstractControl<string | null>): ValidationErrors | null => {
    const value = control.value || '';

    if (INVALID_SHEET_NAME_PATTERN.test(value)) {
      return {
        invalidName: true,
      };
    }

    const normalizedValue = trimSheetName(value).toLowerCase();
    const normalizedSheetNames = getSheetNames().map((name) =>
      trimSheetName(name).toLowerCase()
    );

    if (normalizedValue && normalizedSheetNames.includes(normalizedValue)) {
      return {
        duplicateName: true,
      };
    }

    return null;
  };
};
